import { HEALTH_ROUTES } from '@cdw-ae/routes-shared-api';

/**
 * App controller route constants (root health check)
 *
 * Maps to @Controller()
 */
export const APP_ROUTES = {
  ROOT: HEALTH_ROUTES.ROOT,
} as const;

/**
 * Type representing all possible app routes
 */
export type AppRoute = (typeof APP_ROUTES)[keyof typeof APP_ROUTES];
